import {Platform} from 'react-native';

export default {
  getOS: () => Platform.OS,
  select: Platform.select,
};
